export default "__VITE_ASSET__boejOS0A__"